import * as React from "react";
const StarFill = (props) => (
  <svg
    width={13}
    height={13}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.00922 1.3674L9.07388 3.49672C9.21734 3.7912 9.60243 4.07058 9.92712 4.13099L11.8526 4.44812C13.0833 4.65199 13.3703 5.54299 12.4868 6.43398L10.9842 7.93659C10.7351 8.18577 10.5916 8.67657 10.6746 9.03146L11.105 10.8889C11.4448 12.3538 10.6595 12.9277 9.36836 12.1575L7.56372 11.0853C7.23903 10.889 6.69538 10.889 6.37069 11.0853L4.56605 12.1575C3.27487 12.9201 2.48959 12.3538 2.82937 10.8889L3.25977 9.03146C3.32772 8.66902 3.18426 8.17822 2.93508 7.92904L1.43247 6.42643C0.549032 5.54299 0.835962 4.65199 2.06674 4.44057L3.99219 4.12344C4.31688 4.07058 4.70197 3.78365 4.84543 3.48917L5.9101 1.35985C6.49151 0.212128 7.4278 0.212128 8.00922 1.3674Z"
      fill={props.fill}
    />
  </svg>
);
export default StarFill;
